// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as R3mFonsterfilmRouteImport } from './routes/3m-fonsterfilm'
import { Route as R3mPrestigeRouteImport } from './routes/3m-prestige'
import { Route as R3mPrestige40ExteriorRouteImport } from './routes/3m-prestige-40-exterior'
import { Route as R3mPrestige70RouteImport } from './routes/3m-prestige-70'
import { Route as R3mSakerhetsfilmMedSolfilmRouteImport } from './routes/3m-sakerhetsfilm-med-solfilm'
import { Route as R3mSakerhetsfilmUtanSolfilmRouteImport } from './routes/3m-sakerhetsfilm-utan-solfilm'
import { Route as R3mUltraSakerhetsfilmRouteImport } from './routes/3m-ultra-sakerhetsfilm'
import { Route as AuktoriseradInstallatorRouteImport } from './routes/auktoriserad-installator'
import { Route as CookiepolicyRouteImport } from './routes/cookiepolicy'
import { Route as DatabladRouteImport } from './routes/datablad'
import { Route as DekorfilmRouteImport } from './routes/dekorfilm'
import { Route as FrostatGlasVsDekorfolieRouteImport } from './routes/frostat-glas-vs-dekorfolie'
import { Route as GuiderRouteImport } from './routes/guider'
import { Route as InsynsskyddFonsterRouteImport } from './routes/insynsskydd-fonster'
import { Route as IntegritetspolicyRouteImport } from './routes/integritetspolicy'
import { Route as KontaktRouteImport } from './routes/kontakt'
import { Route as OffertRouteImport } from './routes/offert'
import { Route as OmFonsterfilmRouteImport } from './routes/om-fonsterfilm'
import { Route as OmOssRouteImport } from './routes/om-oss'
import { Route as OrdlistaRouteImport } from './routes/ordlista'
import { Route as PriserRouteImport } from './routes/priser'
import { Route as RadgivningRouteImport } from './routes/radgivning'
import { Route as ReferenserRouteImport } from './routes/referenser'
import { Route as SakerhetsfilmRouteImport } from './routes/sakerhetsfilm'
import { Route as SakerhetsfilmButikRouteImport } from './routes/sakerhetsfilm-butik'
import { Route as SakerhetsfilmFastighetRouteImport } from './routes/sakerhetsfilm-fastighet'
import { Route as SakerhetsfilmKontorRouteImport } from './routes/sakerhetsfilm-kontor'
import { Route as SakerhetsfilmSkyddsklassEn12600GuideRouteImport } from './routes/sakerhetsfilm-skyddsklass-en12600-guide'
import { Route as Solfilm3mPrestigeVsSolarScreenRouteImport } from './routes/solfilm-3m-prestige-vs-solar-screen'
import { Route as SolfilmBastITestRouteImport } from './routes/solfilm-bast-i-test'
import { Route as SolfilmForetagRouteImport } from './routes/solfilm-foretag'
import { Route as SolfilmGoteborgRouteImport } from './routes/solfilm-goteborg'
import { Route as SolfilmHelsingborgRouteImport } from './routes/solfilm-helsingborg'
import { Route as SolfilmLundRouteImport } from './routes/solfilm-lund'
import { Route as SolfilmMalmoRouteImport } from './routes/solfilm-malmo'
import { Route as SolfilmPrivatRouteImport } from './routes/solfilm-privat'
import { Route as SolfilmStockholmRouteImport } from './routes/solfilm-stockholm'
import { Route as SplitterskyddFonsterRouteImport } from './routes/splitterskydd-fonster'
import { Route as UvSkyddVarmereduktionRouteImport } from './routes/uv-skydd-varmereduktion'
import { Route as VanligaFragorRouteImport } from './routes/vanliga-fragor'
import { Route as VillkorRouteImport } from './routes/villkor'
import { Route as DekorfilmIndexRouteImport } from './routes/dekorfilm.index'
import { Route as GuiderIndexRouteImport } from './routes/guider.index'
import { Route as GuiderDekorfilmFrostatGlasRouteImport } from './routes/guider.dekorfilm-frostat-glas'
import { Route as GuiderSakerhetsfilmInbrottsskyddRouteImport } from './routes/guider.sakerhetsfilm-inbrottsskydd'
import { Route as GuiderSolfilmKontorRouteImport } from './routes/guider.solfilm-kontor'
import { Route as GuiderSolfilmVillaRouteImport } from './routes/guider.solfilm-villa'
import { Route as GuiderSolfilmVsPersiennerRouteImport } from './routes/guider.solfilm-vs-persienner'
import { Route as GuiderUnderhallLivslangdRouteImport } from './routes/guider.underhall-livslangd'
import { Route as SakerhetsfilmIndexRouteImport } from './routes/sakerhetsfilm.index'
import { Route as SakerhetsfilmSolarScreenRouteImport } from './routes/sakerhetsfilm.solar-screen'
import { Route as SolfilmForetagIndexRouteImport } from './routes/solfilm-foretag.index'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const R3mFonsterfilmRoute = R3mFonsterfilmRouteImport.update({
            id: '/3m-fonsterfilm',path: '/3m-fonsterfilm',getParentRoute: () => rootRouteImport
          })
const R3mPrestigeRoute = R3mPrestigeRouteImport.update({
            id: '/3m-prestige',path: '/3m-prestige',getParentRoute: () => rootRouteImport
          })
const R3mPrestige40ExteriorRoute = R3mPrestige40ExteriorRouteImport.update({
            id: '/3m-prestige-40-exterior',path: '/3m-prestige-40-exterior',getParentRoute: () => rootRouteImport
          })
const R3mPrestige70Route = R3mPrestige70RouteImport.update({
            id: '/3m-prestige-70',path: '/3m-prestige-70',getParentRoute: () => rootRouteImport
          })
const R3mSakerhetsfilmMedSolfilmRoute = R3mSakerhetsfilmMedSolfilmRouteImport.update({
            id: '/3m-sakerhetsfilm-med-solfilm',path: '/3m-sakerhetsfilm-med-solfilm',getParentRoute: () => rootRouteImport
          })
const R3mSakerhetsfilmUtanSolfilmRoute = R3mSakerhetsfilmUtanSolfilmRouteImport.update({
            id: '/3m-sakerhetsfilm-utan-solfilm',path: '/3m-sakerhetsfilm-utan-solfilm',getParentRoute: () => rootRouteImport
          })
const R3mUltraSakerhetsfilmRoute = R3mUltraSakerhetsfilmRouteImport.update({
            id: '/3m-ultra-sakerhetsfilm',path: '/3m-ultra-sakerhetsfilm',getParentRoute: () => rootRouteImport
          })
const AuktoriseradInstallatorRoute = AuktoriseradInstallatorRouteImport.update({
            id: '/auktoriserad-installator',path: '/auktoriserad-installator',getParentRoute: () => rootRouteImport
          })
const CookiepolicyRoute = CookiepolicyRouteImport.update({
            id: '/cookiepolicy',path: '/cookiepolicy',getParentRoute: () => rootRouteImport
          })
const DatabladRoute = DatabladRouteImport.update({
            id: '/datablad',path: '/datablad',getParentRoute: () => rootRouteImport
          })
const DekorfilmRoute = DekorfilmRouteImport.update({
            id: '/dekorfilm',path: '/dekorfilm',getParentRoute: () => rootRouteImport
          })
const FrostatGlasVsDekorfolieRoute = FrostatGlasVsDekorfolieRouteImport.update({
            id: '/frostat-glas-vs-dekorfolie',path: '/frostat-glas-vs-dekorfolie',getParentRoute: () => rootRouteImport
          })
const GuiderRoute = GuiderRouteImport.update({
            id: '/guider',path: '/guider',getParentRoute: () => rootRouteImport
          })
const InsynsskyddFonsterRoute = InsynsskyddFonsterRouteImport.update({
            id: '/insynsskydd-fonster',path: '/insynsskydd-fonster',getParentRoute: () => rootRouteImport
          })
const IntegritetspolicyRoute = IntegritetspolicyRouteImport.update({
            id: '/integritetspolicy',path: '/integritetspolicy',getParentRoute: () => rootRouteImport
          })
const KontaktRoute = KontaktRouteImport.update({
            id: '/kontakt',path: '/kontakt',getParentRoute: () => rootRouteImport
          })
const OffertRoute = OffertRouteImport.update({
            id: '/offert',path: '/offert',getParentRoute: () => rootRouteImport
          })
const OmFonsterfilmRoute = OmFonsterfilmRouteImport.update({
            id: '/om-fonsterfilm',path: '/om-fonsterfilm',getParentRoute: () => rootRouteImport
          })
const OmOssRoute = OmOssRouteImport.update({
            id: '/om-oss',path: '/om-oss',getParentRoute: () => rootRouteImport
          })
const OrdlistaRoute = OrdlistaRouteImport.update({
            id: '/ordlista',path: '/ordlista',getParentRoute: () => rootRouteImport
          })
const PriserRoute = PriserRouteImport.update({
            id: '/priser',path: '/priser',getParentRoute: () => rootRouteImport
          })
const RadgivningRoute = RadgivningRouteImport.update({
            id: '/radgivning',path: '/radgivning',getParentRoute: () => rootRouteImport
          })
const ReferenserRoute = ReferenserRouteImport.update({
            id: '/referenser',path: '/referenser',getParentRoute: () => rootRouteImport
          })
const SakerhetsfilmRoute = SakerhetsfilmRouteImport.update({
            id: '/sakerhetsfilm',path: '/sakerhetsfilm',getParentRoute: () => rootRouteImport
          })
const SakerhetsfilmButikRoute = SakerhetsfilmButikRouteImport.update({
            id: '/sakerhetsfilm-butik',path: '/sakerhetsfilm-butik',getParentRoute: () => rootRouteImport
          })
const SakerhetsfilmFastighetRoute = SakerhetsfilmFastighetRouteImport.update({
            id: '/sakerhetsfilm-fastighet',path: '/sakerhetsfilm-fastighet',getParentRoute: () => rootRouteImport
          })
const SakerhetsfilmKontorRoute = SakerhetsfilmKontorRouteImport.update({
            id: '/sakerhetsfilm-kontor',path: '/sakerhetsfilm-kontor',getParentRoute: () => rootRouteImport
          })
const SakerhetsfilmSkyddsklassEn12600GuideRoute = SakerhetsfilmSkyddsklassEn12600GuideRouteImport.update({
            id: '/sakerhetsfilm-skyddsklass-en12600-guide',path: '/sakerhetsfilm-skyddsklass-en12600-guide',getParentRoute: () => rootRouteImport
          })
const Solfilm3mPrestigeVsSolarScreenRoute = Solfilm3mPrestigeVsSolarScreenRouteImport.update({
            id: '/solfilm-3m-prestige-vs-solar-screen',path: '/solfilm-3m-prestige-vs-solar-screen',getParentRoute: () => rootRouteImport
          })
const SolfilmBastITestRoute = SolfilmBastITestRouteImport.update({
            id: '/solfilm-bast-i-test',path: '/solfilm-bast-i-test',getParentRoute: () => rootRouteImport
          })
const SolfilmForetagRoute = SolfilmForetagRouteImport.update({
            id: '/solfilm-foretag',path: '/solfilm-foretag',getParentRoute: () => rootRouteImport
          })
const SolfilmGoteborgRoute = SolfilmGoteborgRouteImport.update({
            id: '/solfilm-goteborg',path: '/solfilm-goteborg',getParentRoute: () => rootRouteImport
          })
const SolfilmHelsingborgRoute = SolfilmHelsingborgRouteImport.update({
            id: '/solfilm-helsingborg',path: '/solfilm-helsingborg',getParentRoute: () => rootRouteImport
          })
const SolfilmLundRoute = SolfilmLundRouteImport.update({
            id: '/solfilm-lund',path: '/solfilm-lund',getParentRoute: () => rootRouteImport
          })
const SolfilmMalmoRoute = SolfilmMalmoRouteImport.update({
            id: '/solfilm-malmo',path: '/solfilm-malmo',getParentRoute: () => rootRouteImport
          })
const SolfilmPrivatRoute = SolfilmPrivatRouteImport.update({
            id: '/solfilm-privat',path: '/solfilm-privat',getParentRoute: () => rootRouteImport
          })
const SolfilmStockholmRoute = SolfilmStockholmRouteImport.update({
            id: '/solfilm-stockholm',path: '/solfilm-stockholm',getParentRoute: () => rootRouteImport
          })
const SplitterskyddFonsterRoute = SplitterskyddFonsterRouteImport.update({
            id: '/splitterskydd-fonster',path: '/splitterskydd-fonster',getParentRoute: () => rootRouteImport
          })
const UvSkyddVarmereduktionRoute = UvSkyddVarmereduktionRouteImport.update({
            id: '/uv-skydd-varmereduktion',path: '/uv-skydd-varmereduktion',getParentRoute: () => rootRouteImport
          })
const VanligaFragorRoute = VanligaFragorRouteImport.update({
            id: '/vanliga-fragor',path: '/vanliga-fragor',getParentRoute: () => rootRouteImport
          })
const VillkorRoute = VillkorRouteImport.update({
            id: '/villkor',path: '/villkor',getParentRoute: () => rootRouteImport
          })
const DekorfilmIndexRoute = DekorfilmIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DekorfilmRoute
          })
const GuiderIndexRoute = GuiderIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => GuiderRoute
          })
const GuiderDekorfilmFrostatGlasRoute = GuiderDekorfilmFrostatGlasRouteImport.update({
            id: '/dekorfilm-frostat-glas',path: '/dekorfilm-frostat-glas',getParentRoute: () => GuiderRoute
          })
const GuiderSakerhetsfilmInbrottsskyddRoute = GuiderSakerhetsfilmInbrottsskyddRouteImport.update({
            id: '/sakerhetsfilm-inbrottsskydd',path: '/sakerhetsfilm-inbrottsskydd',getParentRoute: () => GuiderRoute
          })
const GuiderSolfilmKontorRoute = GuiderSolfilmKontorRouteImport.update({
            id: '/solfilm-kontor',path: '/solfilm-kontor',getParentRoute: () => GuiderRoute
          })
const GuiderSolfilmVillaRoute = GuiderSolfilmVillaRouteImport.update({
            id: '/solfilm-villa',path: '/solfilm-villa',getParentRoute: () => GuiderRoute
          })
const GuiderSolfilmVsPersiennerRoute = GuiderSolfilmVsPersiennerRouteImport.update({
            id: '/solfilm-vs-persienner',path: '/solfilm-vs-persienner',getParentRoute: () => GuiderRoute
          })
const GuiderUnderhallLivslangdRoute = GuiderUnderhallLivslangdRouteImport.update({
            id: '/underhall-livslangd',path: '/underhall-livslangd',getParentRoute: () => GuiderRoute
          })
const SakerhetsfilmIndexRoute = SakerhetsfilmIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => SakerhetsfilmRoute
          })
const SakerhetsfilmSolarScreenRoute = SakerhetsfilmSolarScreenRouteImport.update({
            id: '/solar-screen',path: '/solar-screen',getParentRoute: () => SakerhetsfilmRoute
          })
const SolfilmForetagIndexRoute = SolfilmForetagIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => SolfilmForetagRoute
          })





const DekorfilmRouteChildren = {
  DekorfilmIndexRoute: DekorfilmIndexRoute
}

const DekorfilmRouteWithChildren = DekorfilmRoute._addFileChildren(DekorfilmRouteChildren)




const GuiderRouteChildren = {
  GuiderDekorfilmFrostatGlasRoute: GuiderDekorfilmFrostatGlasRoute,GuiderSakerhetsfilmInbrottsskyddRoute: GuiderSakerhetsfilmInbrottsskyddRoute,GuiderSolfilmKontorRoute: GuiderSolfilmKontorRoute,GuiderSolfilmVillaRoute: GuiderSolfilmVillaRoute,GuiderSolfilmVsPersiennerRoute: GuiderSolfilmVsPersiennerRoute,GuiderUnderhallLivslangdRoute: GuiderUnderhallLivslangdRoute,GuiderIndexRoute: GuiderIndexRoute
}

const GuiderRouteWithChildren = GuiderRoute._addFileChildren(GuiderRouteChildren)




const SakerhetsfilmRouteChildren = {
  SakerhetsfilmSolarScreenRoute: SakerhetsfilmSolarScreenRoute,SakerhetsfilmIndexRoute: SakerhetsfilmIndexRoute
}

const SakerhetsfilmRouteWithChildren = SakerhetsfilmRoute._addFileChildren(SakerhetsfilmRouteChildren)




const SolfilmForetagRouteChildren = {
  SolfilmForetagIndexRoute: SolfilmForetagIndexRoute
}

const SolfilmForetagRouteWithChildren = SolfilmForetagRoute._addFileChildren(SolfilmForetagRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,R3mFonsterfilmRoute: R3mFonsterfilmRoute,R3mPrestigeRoute: R3mPrestigeRoute,R3mPrestige40ExteriorRoute: R3mPrestige40ExteriorRoute,R3mPrestige70Route: R3mPrestige70Route,R3mSakerhetsfilmMedSolfilmRoute: R3mSakerhetsfilmMedSolfilmRoute,R3mSakerhetsfilmUtanSolfilmRoute: R3mSakerhetsfilmUtanSolfilmRoute,R3mUltraSakerhetsfilmRoute: R3mUltraSakerhetsfilmRoute,AuktoriseradInstallatorRoute: AuktoriseradInstallatorRoute,CookiepolicyRoute: CookiepolicyRoute,DatabladRoute: DatabladRoute,DekorfilmRoute: DekorfilmRouteWithChildren,FrostatGlasVsDekorfolieRoute: FrostatGlasVsDekorfolieRoute,GuiderRoute: GuiderRouteWithChildren,InsynsskyddFonsterRoute: InsynsskyddFonsterRoute,IntegritetspolicyRoute: IntegritetspolicyRoute,KontaktRoute: KontaktRoute,OffertRoute: OffertRoute,OmFonsterfilmRoute: OmFonsterfilmRoute,OmOssRoute: OmOssRoute,OrdlistaRoute: OrdlistaRoute,PriserRoute: PriserRoute,RadgivningRoute: RadgivningRoute,ReferenserRoute: ReferenserRoute,SakerhetsfilmRoute: SakerhetsfilmRouteWithChildren,SakerhetsfilmButikRoute: SakerhetsfilmButikRoute,SakerhetsfilmFastighetRoute: SakerhetsfilmFastighetRoute,SakerhetsfilmKontorRoute: SakerhetsfilmKontorRoute,SakerhetsfilmSkyddsklassEn12600GuideRoute: SakerhetsfilmSkyddsklassEn12600GuideRoute,Solfilm3mPrestigeVsSolarScreenRoute: Solfilm3mPrestigeVsSolarScreenRoute,SolfilmBastITestRoute: SolfilmBastITestRoute,SolfilmForetagRoute: SolfilmForetagRouteWithChildren,SolfilmGoteborgRoute: SolfilmGoteborgRoute,SolfilmHelsingborgRoute: SolfilmHelsingborgRoute,SolfilmLundRoute: SolfilmLundRoute,SolfilmMalmoRoute: SolfilmMalmoRoute,SolfilmPrivatRoute: SolfilmPrivatRoute,SolfilmStockholmRoute: SolfilmStockholmRoute,SplitterskyddFonsterRoute: SplitterskyddFonsterRoute,UvSkyddVarmereduktionRoute: UvSkyddVarmereduktionRoute,VanligaFragorRoute: VanligaFragorRoute,VillkorRoute: VillkorRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)